import React, { useState, useEffect } from 'react';
import Rater from 'react-rater';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import { get } from 'lodash';
import moment from 'moment';
import ClassScheduleModal, {
  getDateTimeFromSelectedTimeSlice,
} from 'components/mentoring/ClassScheduleModal';
import MentoringCancelModal from 'components/mentoring/MentoringCancelModal';
import MentoringClassStatus from 'components/mentoring/MentoringClassStatus';
import { ClassViewCommon } from 'components/mentoring/MentoringClassView';
import MentoringPastClass from 'components/mentoring/MentoringPastClass';
import { ProfileWrapper } from 'components/mentoring/styles';
import { MentoringClassWrapper } from 'components/mentoring/styles';
import { updateMentoringClassSchedule, getMentoringClass } from 'libs/api/mentoring';
import { useDataApi, useTimezone } from 'libs/hooks';
import { showNotification } from 'libs/utils';
import { TMentoringClass, TSelectedTimeSlice, TUpdateMentoringClassSchedule } from 'modules/mentoring';
import { RouteMatch, TModalState } from 'modules/types';
import { CWindowWidth, CDefaultDateTimeFormat } from 'constants/base.const';
import { CNumOfSlice, CNumOfOneHourSlice } from 'constants/mentoring.const';
import { CUserType, CUserTypeColor } from 'constants/user.const';
import { EUserType } from 'enums/base.enum';
import { EMentoringClassStatus } from 'enums/mentoring.enum';
import { EMentoringField } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import { Button, Col, Row, Typography, Form, Divider, Spin, Tag, message } from 'antd';
import { CalendarOutlined, LikeFilled } from '@ant-design/icons';

const { Text, Title } = Typography;
const MenteeClassView = ({ recordId }: { recordId: number }) => {
  const [form] = Form.useForm();
  const getPromise = getMentoringClass.bind(null, recordId);
  const [{ data, loading }, setCallback] = useDataApi<TMentoringClass>(getPromise);
  const [classScheduleModal, setClassScheduleModal] = useState(false);
  const [mentoringCancelModal, setMentoringCancelModal] = useState<TModalState>({
    visible: false,
  });
  const [getDateTime, timezone] = useTimezone();
  const [numOfSlice, setNumOfSlice] = useState<number>(0);

  const history = useHistory();
  const match = useRouteMatch(`${ERoute.MentoringClassView}`);
  const { record_id } = (match?.params as RouteMatch) || {};

  useEffect(() => {
    if (data && !loading) {
      setCallback(() => getPromise);
    }
  }, [recordId]);

  useEffect(() => {
    if (data?.mentor.mentoring_field === EMentoringField.Consulting) {
      setNumOfSlice(CNumOfSlice); // 3
    } else {
      //멘토가 finance혹은 tech 멘토일 때
      setNumOfSlice(CNumOfOneHourSlice); // 2
    }
  }, [data]);

  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload();
    }, 60000)
    return () => {
      clearInterval(interval);
    };
  }, []);

  const tags = []
  const mentoring_tags = get(data, 'mentor.mentoring_tags', [])
  const mentoring_tags_length = mentoring_tags.length > 2 ? 2 : mentoring_tags.length
  for (let index = 0; index < mentoring_tags_length; index++) {
    tags.push(
      <Col style={{ width: '100%', marginTop: '5px' }}>
        <Button
          size='small'
          type='link'
          style={{ width: '100%', fontSize: '13px', margin: '3px' }}
          icon={<LikeFilled />}
          >
            { mentoring_tags[index] }
        </Button>
      </Col>
    );
  }

  return (
    <MentoringClassWrapper>
      <Spin tip='loading...' spinning={loading}>
        <Row
          style={{
            maxWidth: `${CWindowWidth - 300}px`,
            margin: '20px auto',
            padding: '30px 10px',
          }}
          gutter={[32, 16]}
        >
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 17, order: 1 }}
            lg={{ span: 17, order: 1 }}
            xl={{ span: 17, order: 1 }}
          >
            <Title level={2} style={{ marginBottom: '0px' }}>
              멘토링 상세
            </Title>
            <Row justify='space-between' align='bottom' style={{ marginTop: '30px' }}>
              <Col>
                {/* memo가 있으면!!(취소 혹은 거절 상태이면) 취소 사유 혹은 거절 사유 쓴 것  여기에 그대로*/}
                {/* status 태그로 표시하고 & 날짜까지 있는 컴포너트 */}
                <MentoringClassStatus record={data} />
                {/* 취소 혹은 거절 사유 아래다가 */}
                {get(data, 'memo') && (
                  <div className='content-block' style={{ marginTop: '10px' }}>
                    {get(data, 'memo')}
                  </div>
                )}
              </Col>
              <Col>
                {(get(data, 'status') === EMentoringClassStatus.RequestAccepted ||
                  get(data, 'status') === EMentoringClassStatus.RequestPending) && (
                  <>
                    <Button
                      // disabled={true}
                      // onClick={()=> {message.error("현재 사용할 수 없는 기능입니다.")}}
                      //멘토링 일정 변경 슬랏에도 컨설팅  /  파이낸스, 테크에따라 90,60분 차이
                      onClick={() => {
                        if (moment(get(data, 'start_at')).diff(moment(), 'minutes') <= 24 * 60) {
                          message.error(
                            `멘토링 시작 24시간 이내에는 일정 변경이 불가능 하며, 취소만 가능합니다.${
                              get(data, 'status') === EMentoringClassStatus.RequestAccepted
                                ? 'Credit 은 환급되지 않습니다)'
                                : ''
                            }`,
                          );
                          return;
                        } else {
                          setClassScheduleModal(true);
                        }
                      }}
                      style={{ marginRight: '5px' }}
                    >
                      <CalendarOutlined />
                      일정변경
                    </Button>

                    <Button
                      onClick={() => {
                        setMentoringCancelModal({
                          visible: true,
                          record: data,
                          onFinish: () => {
                            setCallback(() => getPromise);
                            showNotification('success', '멘토링이 취소되었습니다.');
                          },
                        });
                      }}
                      danger
                    >
                      멘토링 취소
                    </Button>
                  </>
                )}
                {get(data, 'status') === EMentoringClassStatus.Completed &&
                  get(data, 'is_attended') === true && (
                    <>
                      {get(data, 'feedback') ? (
                        <Link to={`${ERoute.MentoringFeedback}/view/${get(data, 'feedback')}`}>
                          <Button>피드백 보기</Button>
                        </Link>
                      ) : (
                        <Button className='btn-disabled'>피드백 보기</Button>
                      )}
                    </>
                  )}
              </Col>
            </Row>
            <ClassViewCommon record={data} />
            <Divider className='class-divider-32' />
            <div style={{ marginBottom: '10px' }} className='content-title'>
              멘토와의 지난 멘토링
            </div>
            {!loading && <MentoringPastClass withId={get(data, 'mentor.id')} targetType={EUserType.Mentor} />}
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 6, offset: 1 }}
            lg={{ span: 6, offset: 1 }}
            xl={{ span: 6, offset: 1 }}
            style={{ textAlign: 'center' }}
          >
            <div className='border-box'>
              <ProfileWrapper style={{ maxWidth: '200px' }}>
                <Link
                  to={`${ERoute.MentoringMentorView.replace(':record_id', String(get(data, 'mentor.id')))}`}
                >
                  <img alt='profile_image' src={get(data, 'mentor.user.profile_image.absolute_url')} />
                </Link>
                <Tag className='user-type-tag' color={CUserTypeColor[EUserType.Mentor]}>
                  {CUserType[EUserType.Mentor]}
                </Tag>
                <div className='name'>{get(data, 'mentor.user.fullname')}</div>
                <div className='intro'>"{get(data, 'mentor.short_introduction')}"</div>
                <Rater interactive={false} rating={get(data, 'mentor.score_average')} />
                <div>
                  <span className='score'>{get(data, 'mentor.score_average')}</span>
                </div>
                <div className='score' style={{ marginTop: '5px' }}>
                  멘토링 횟수 {get(data, 'mentor.mentoring_count', 0)}회<br />
                  리뷰 수 {get(data, 'mentor.num_of_rater', 0)}개
                </div>
                { tags }
                <br />
              </ProfileWrapper>
              {get(data, 'status') === EMentoringClassStatus.RequestAccepted &&
                get(data, 'meeting_url', '').length > 0 && (
                  <>
                    {get(data, 'meeting_url') === 'inactive' ? (
                      <Button
                        style={{ width: '100%', marginBottom: '5px' }}
                        className='btn-join'
                        onClick={() => {
                          message.error('멘토링 10분전부터 입장 가능합니다');
                        }}
                      >
                        멘토링 참여하기
                      </Button>
                    ) : (
                      <Button
                        href={get(data, 'meeting_url')}
                        target='_blank'
                        style={{ width: '100%', marginBottom: '5px' }}
                        className='btn-join'
                      >
                        멘토링 참여하기
                      </Button>
                    )}
                  </>
                )}
              <Link
                to={`${ERoute.MentoringMentorView.replace(':record_id', String(get(data, 'mentor.id')))}`}
              >
                <Button style={{ width: '100%' }}>{get(data, 'mentor.user.fullname')} 멘토 상세보기</Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Spin>
      <MentoringCancelModal modalState={mentoringCancelModal} setModalState={setMentoringCancelModal} />
      <ClassScheduleModal
        numOfSlice={numOfSlice}
        mentor={get(data, 'mentor')}
        forUpdateMentoringClassId={get(data, 'id')}
        visible={classScheduleModal}
        setVisible={setClassScheduleModal}
        onFinish={async (selectedTimes: Array<TSelectedTimeSlice>) => {
          if (selectedTimes && selectedTimes.length > 0) {
            const selectedTime = getDateTimeFromSelectedTimeSlice(selectedTimes[0], timezone);
            try {
              await updateMentoringClassSchedule(get(data, 'id'), {
                start_at: selectedTime.format(CDefaultDateTimeFormat),
                end_at: selectedTime
                  .clone()
                  .add(30 * numOfSlice, 'minutes')
                  .format(CDefaultDateTimeFormat),
              } as TUpdateMentoringClassSchedule);

              setCallback(() => getPromise);
              showNotification('success', '요청을 완료했습니다. 멘토가 수락하면 멘토링 일정이 변경됩니다.');
            } catch (e) {
              throw e;
            }
          }
        }}
      />
    </MentoringClassWrapper>
  );
};

export default MenteeClassView;
